import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { environment } from "environments/environment";

@Injectable({
  providedIn: 'root'
})
export class EnvironmentConfigService {
  constructor(private http: HttpClient) {}

  load(): Promise<unknown> {
    return this.http.get('/config.json')
      .toPromise()
      .then((config) => {
	Object.assign(environment, config);
      });
  }
}
